export default "__VITE_ASSET__BYO6CV2A__"